import SpecialItem from './SpecialItem';
import { withI18n } from 'react-i18next';

export default withI18n()(SpecialItem);
